import { Injectable} from "@angular/core";
import {Http} from "@angular/http";
import moment from 'moment-timezone';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { AlertService,UserService } from '../_services/index';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';


@Injectable()
export class Helper {
	pass : any;
	iv : any;
	keySize = 256;
	ivSize = 128;
	iterations = 100;
  backendUrl: any;
  
   constructor(private http: Http ,private userService: UserService) {
   	this.pass = environment.pass;
     this.backendUrl = environment.url; 
   }

   getDateTimeInClientTz(time, zone) {
        var format = 'YYYY-MM-DD HH:mm:ss';
        return moment(time, format).tz('GMT').format(format);
   }

   getEncryptedId(id) {
   	 var msg = ""+id;
   	 var salt = CryptoJS.lib.WordArray.random(128/8);  
  	 var key = CryptoJS.PBKDF2(this.pass, salt, {
      keySize: this.keySize/32,
      iterations: this.iterations
     });

	  var iv = CryptoJS.lib.WordArray.random(128/8);  
	  var encrypted = CryptoJS.AES.encrypt(msg, key, { 
	    iv: iv, 
	    padding: CryptoJS.pad.Pkcs7,
	    mode: CryptoJS.mode.CBC
	    
	  });
  
	  // salt, iv will be hex 32 in length
	  // append them to the ciphertext for use  in decryption
	  var transitmessage = salt.toString()+ iv.toString() + encrypted.toString();
	  //console.log(transitmessage);
	  return transitmessage;
   }

   getDevryptedId(transitmessage) {
   	  var salt = CryptoJS.enc.Hex.parse(transitmessage.substr(0, 32));
	  var iv = CryptoJS.enc.Hex.parse(transitmessage.substr(32, 32))
	  var encrypted = transitmessage.substring(64);	  
	  var key = CryptoJS.PBKDF2(this.pass, salt, {
	      keySize: this.keySize/32,
	      iterations: this.iterations
	    });
	  var decrypted = CryptoJS.AES.decrypt(encrypted, key, { 
	    iv: iv, 
	    padding: CryptoJS.pad.Pkcs7,
	    mode: CryptoJS.mode.CBC
	    
	  })

	  return decrypted;
   }

   getDateTimeInCTz(time, zone) {
        var format = 'YYYY-MM-DD HH:mm:ss';
        return moment(time).tz(zone).format(format);
   }

   getuserDateTimeTz(time,format) {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));         
    let u_locale=currentUser.user_locale ? currentUser.user_locale: 'en_US';
    if (u_locale.indexOf("_")!= -1){
       let arr=u_locale.split('_'); 
         u_locale = arr[0];                    
      }
      else{
           u_locale='en';
      } 
      //console.log("ulocale---------",this.ulocale, typeof this.ulocale);
   	    let test=moment().format("Z");
   	    let date = moment.utc(time).utcOffset(test).locale( u_locale ).format(format);
   	    // console.log(test,date);   
        return date; 
   }

   convertdatetimelang(time,format){
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));         
    let u_locale=currentUser.user_locale ? currentUser.user_locale: 'en_US';
    if (u_locale.indexOf("_")!= -1){
       let arr=u_locale.split('_'); 
         u_locale = arr[0];                    
      }
      else{
           u_locale='en';
      } 
   	    let date = moment.utc(time).locale( u_locale ).format(format);   
        return date; 
   }

     getuserDateTimeTimezone(time, format) {
          let currentUser = JSON.parse(localStorage.getItem('currentUser'));
          let u_locale = currentUser.user_locale ? currentUser.user_locale : 'en_US';
          if (u_locale.indexOf("_") != -1) {
               let arr = u_locale.split('_');
               u_locale = arr[0];
          }
          else {
               u_locale = 'en';
          }
          let test = moment().format("Z");
          let date = moment.utc(time).utcOffset(test).locale(u_locale).format(format);
          if(date != 'Invalid date'){
          let date0 = date.split('-')[0];
          let date1 = date.split('-')[1].charAt(0).toUpperCase() + date.split('-')[1].slice(1)
          let date2 = date.split('-')[2]
          date = date0 + '-' + date1 + '-' + date2
          }
          return date;
     }
   
   getbranchDateTimeTz(time, zone,format) {
    // console.log(time,zone,format);
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));         
    let u_locale=currentUser.user_locale ? currentUser.user_locale: 'en_US';
    if (u_locale.indexOf("_")!= -1){
       let arr=u_locale.split('_'); 
         u_locale = arr[0];                    
      }
      else{
           u_locale='en';
      } 

     if(zone){
        let test=moment(time).tz(zone).format("Z");
        let date = moment.utc(time).utcOffset(test).locale(u_locale).format(format);
          //console.log(test,zone,date);   
        return date;       
     }
     else{
         let test=moment().format("Z");
         let date = moment.utc(time).utcOffset(test).locale( u_locale ).format(format);
             // console.log(test,date);   
             return date; 
       }  
   }


   getlocaleDateTime(time,format) {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));         
    let u_locale=currentUser.user_locale ? currentUser.user_locale: 'en_US';
    if (u_locale.indexOf("_")!= -1){
       let arr=u_locale.split('_'); 
         u_locale = arr[0];                    
      }
      else{
           u_locale='en';
      } 
         let date = moment(time,'DD-MMM-YYYY').locale(u_locale).format(format);
         // console.log(test,date);   
        return date; 
   }
 
   getlocaleDT(time,format) {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));         
    let u_locale=currentUser.user_locale ? currentUser.user_locale: 'en_US';
    if (u_locale.indexOf("_")!= -1){
       let arr=u_locale.split('_'); 
         u_locale = arr[0];                    
      }
      else{
           u_locale='en';
      } 
         let date = moment(time,'DD-MMM-YYYY HH:mm').locale(u_locale).format(format);
         // console.log(test,date);   
        return date; 
   } 
   timezoneValue(value:any){
     if(value=="America/Mexico_City"){
             return "Etc/GMT+6";
     }
     else if(value=="America/Mazatlan"){
       return "Etc/GMT+7";
     }
     else if(value=="America/Cancun"){
       return "Etc/GMT+5";
     }
     else if(value=="America/Monterrey"){
       return "Etc/GMT+6";
     }
     else if(value=="America/Tijuana"){  //i -8
       return "Etc/GMT-8";
     }
     else if(value=="America/Hermosillo"){
       return "Etc/GMT+7";
     }
     else if(value=="America/Chihuahua"){
       return "Etc/GMT+6";
     }
     else if(value=="America/Ciudad_Juarez"){ //i -7
      return "Etc/GMT+6";
    }  else if(value=="America/Matamoros"){  //i -6
      return "Etc/GMT+6";
    }  else if(value=="America/Ojinaga"){ //i -6
      return "Etc/GMT+5";
    }else{
       return value;
     }
     
   }
   etcTimezoneValue(value:any){
    if(value=="Etc/GMT+6"){
      return ["America/Mexico_City","America/Monterrey","America/Chihuahua","America/Ciudad_Juarez"]
    }
    else if(value=="Etc/GMT+7"){
      return ["America/Tijuana","America/Mazatlan","America/Hermosillo"]
    }
    else if(value=="Etc/GMT+5"){
      return ["America/Cancun","America/Matamoros","America/Ojinaga"]
    }else{
      return [value];
    }
    
  }

  writeactivtylog(data) {
    this.userService.dashboard_activity_log(this.backendUrl, data).subscribe(response => {
      console.log(response);
    });
  }

  download_csvfile(col,name,data_val){
    let col_val = col;
    console.log(col_val);
    var options = {
      title: name,
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      showTitle: false,
      headers: [col_val]
    };
    let data = data_val;
    
    
  
    new Angular2Csv(data, name, options);

  }

  findDifferingKeys(obj1, obj2) {
    let differingKeys = [];
  
    const compareObjects = (obj1, obj2, currentKey) => {
      for (let key in obj1) {
        if (obj1.hasOwnProperty(key)) {
          const newKey = currentKey ? `${currentKey}.${key}` : key;
  
          if (!obj2.hasOwnProperty(key)) {
            differingKeys.push(newKey);
          } else if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
            compareObjects(obj1[key], obj2[key], newKey);
          } else if (obj1[key] !== obj2[key]) {
            differingKeys.push(newKey);
          }
        }
      }
    };
  
    compareObjects(obj1, obj2, '');
  
    return differingKeys;
  }
}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_helpers/helper.ts